/** Terms of Service. The text is client/public/terms.html; see StaticLegalPage. */
import StaticLegalPage from './StaticLegalPage';

export default function TermsOfService() {
  return <StaticLegalPage doc="terms" />;
}
